module.exports = __webpack_public_path__ + "img/seller4.62f6daaf.jpg";